// extracted by mini-css-extract-plugin
export default {"input_wrapper":"PasswordInput_input_wrapper__G5xN5","hide_button":"PasswordInput_hide_button__sZzDp","shimmer":"PasswordInput_shimmer__DVex7"};